import { createFileRoute } from "@tanstack/react-router";
import { GroupsStep } from "#/modules/les.planning/components/preparation-steps";
import { groupsStepOptions } from "#/modules/les.planning/preparation-routes";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/week/les/groups",
)({ ...groupsStepOptions, component: Step });

function Step() {
  const navigate = Route.useNavigate();
  return (
    <GroupsStep
      data={Route.useLoaderData()}
      search={Route.useSearch()}
      onChange={(patch) =>
        void navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
